<template>
  <!-- TODO: Добавить состояние загрузки с сохранением высоты инвестиционного блока. -->
  <IndicatorsWrapper :list="visibleIndicatorList" title="Инвестиции" source="Банк России">
    <template #item="{ item }">
      <p class="text-align-left fs14 fw600 mb-6">{{ item.title }}</p>
      <template v-if="item.value">
        <div class="d-flex align-items-center">
          <strong class="fs22 fw700 mr-8 text-nowrap">{{ item.value == '0,00' ? '-' : item.value }} </strong>
          <div>
            <div class="fs12">млн $</div>
          </div>
        </div>
        <div class="analytics-source-text" v-if="item.place">
          <template v-if="item.value != '0,00'"> {{ item.place }} место </template>
        </div>
        <div
          class="analytics-source-text"
          v-if="item.percent"
          :class="[{ 'text-green': item.percent >= 0 }, { 'text-red': item.percent < 0 }]"
        >
          {{ item.percent.toFixed(2) }}%
        </div>
      </template>
      <template v-else-if="item.place">
        <strong>{{ item.place }} место</strong>
      </template>
    </template>
  </IndicatorsWrapper>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import text from '@/common/mixins/text';

  import { COUNTRY_ANALYTICS_ACTIONS_NAME, COUNTRY_ANALYTICS_GETTERS_NAME } from '../../store/analytics/directoryNames';
  import IndicatorsWrapper from '../IndicatorsWrapper.vue';

  export default {
    name: 'InvestmentsRussiaEconRev',
    components: {
      IndicatorsWrapper,
    },
    mixins: [text],
    props: {
      countryId: {
        type: String,
        default: '',
      },
      year: {
        type: Number,
        default: null,
      },
    },
    created() {
      this.loadData();
    },
    computed: {
      ...mapGetters({
        getInStockInvestment: COUNTRY_ANALYTICS_GETTERS_NAME.getInStockInvestment,
        getOutStockInvestment: COUNTRY_ANALYTICS_GETTERS_NAME.getOutStockInvestment,
        getInFlowsInvestment: COUNTRY_ANALYTICS_GETTERS_NAME.getInFlowsInvestment,
        getOutFlowsInvestment: COUNTRY_ANALYTICS_GETTERS_NAME.getOutFlowsInvestment,
      }),
      visibleIndicatorList() {
        return [
          {
            id: 8,
            title: 'Входящие ПИИ, запас',
            period: `${this.getInStockInvestment?.yearPeriod} год`,
            value: this.getInStockInvestment?.value ? this.formatNumber(this.getInStockInvestment.value, 0) : '',
          },
          {
            id: 9,
            title: 'Исходящие ПИИ, запас',
            period: `${this.getOutStockInvestment?.yearPeriod} год`,
            value: this.getOutStockInvestment?.value ? this.formatNumber(this.getOutStockInvestment?.value, 0) : '',
          },
          {
            id: 10,
            title: 'Входящие ПИИ, поток',
            period: `${this.getInFlowsInvestment?.yearPeriod} год`,
            value: this.getInFlowsInvestment?.value ? this.formatNumber(this.getInFlowsInvestment.value, 0) : '',
          },
          {
            id: 11,
            title: 'Исходящие ПИИ, поток',
            period: `${this.getOutFlowsInvestment?.yearPeriod} год`,
            value: this.getOutFlowsInvestment?.value ? this.formatNumber(this.getOutFlowsInvestment.value, 0) : '',
          },
        ].filter((x) => x.value !== '');
      },
    },
    methods: {
      ...mapActions({
        getInvestmentInStock: COUNTRY_ANALYTICS_ACTIONS_NAME.getInvestmentInStock,
        getInvestmentOutStock: COUNTRY_ANALYTICS_ACTIONS_NAME.getInvestmentOutStock,
        getInvestmentInFlows: COUNTRY_ANALYTICS_ACTIONS_NAME.getInvestmentInFlows,
        getInvestmentOutFlows: COUNTRY_ANALYTICS_ACTIONS_NAME.getInvestmentOutFlows,
      }),
      async loadData() {
        if (!this.year) return;

        this.loading = true;
        try {
          await Promise.all([
            this.getInvestmentInStock({ countryId: this.countryId, year: this.year }),
            this.getInvestmentOutStock({ countryId: this.countryId, year: this.year }),
            this.getInvestmentInFlows({ countryId: this.countryId, year: this.year }),
            this.getInvestmentOutFlows({ countryId: this.countryId, year: this.year }),
          ]);
        } finally {
          this.loading = false;
        }
      },
    },
    watch: {
      countryId: function () {
        this.loadData();
      },
      year: function () {
        this.loadData();
      },
    },
  };
</script>
